import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { PARAM_EMPTY_VALUE } from "../constants";
import { convertKeysToIntervals, createInterval } from "./utils";
import { AdaptiveProjection } from "./AdaptiveProjection";
var NonExistentKey = Symbol('NonExistentKey');

// TODO: Возможно архитектурно прокидывать childUtils из фабрики - это не очень правильно,
//  можно вынести функции вроде клонирования в контекст исполнения, если такой появится
// eslint-disable-next-line prettier/prettier
export var AdaptiveDecorator = /*#__PURE__*/function (_AdaptiveProjection) {
  _inherits(AdaptiveDecorator, _AdaptiveProjection);
  var _super = _createSuper(AdaptiveDecorator);
  function AdaptiveDecorator(value, params, childUtils) {
    var _this;
    _classCallCheck(this, AdaptiveDecorator);
    _this = _super.call(this, value, params);
    _this.value = value;
    _this.params = params;
    _this.childUtils = childUtils;
    return _this;
  }
  _createClass(AdaptiveDecorator, [{
    key: "fillValue",
    value: function fillValue(currentKey) {
      var cloneTopInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (currentKey && !(currentKey in this.value)) {
        var closestKey = this.getClosestKey(currentKey);

        /**
         * Which value to clone where matters,
         * because value under `currentKey` is going to change
         */
        if (cloneTopInterval) {
          this.value[currentKey] = this.value[closestKey];
          this.value[closestKey] = this.childUtils.clone(this.value[closestKey], {
            // ...this.params,
            size: closestKey
          });
        } else {
          this.value[currentKey] = this.childUtils.clone(this.value[closestKey], {
            // ...this.params,
            size: currentKey
          });
        }
      }
    }

    /**
     * ChangeSubscriber interface
     *
     * If child value changed, we fill both max and min independently of child interval
     * One of the edge cases may be excessive, favoring code readability over performance
     */
  }, {
    key: "onChildWillChange",
    value: function onChildWillChange(params) {
      var _params$maxSize = params.maxSize,
        maxSize = _params$maxSize === void 0 ? PARAM_EMPTY_VALUE : _params$maxSize,
        _params$minSize = params.minSize,
        minSize = _params$minSize === void 0 ? null : _params$minSize;
      this.fillValue(maxSize, true);
      this.fillValue(minSize);
    }
  }, {
    key: "onChildDidChange",
    value: function onChildDidChange() {
      var _this2 = this;
      var prevProp = NonExistentKey;
      this.getSortedKeys().forEach(function (key) {
        var currentProp = _this2.value[key];
        if (_this2.childUtils.deepEqual(currentProp, prevProp)) delete _this2.value[key];
        prevProp = currentProp;
      });
    }
  }, {
    key: "accept",
    value: function accept(visitor) {
      var _this3 = this;
      convertKeysToIntervals(this.getSortedKeys()).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          currentMaxSize = _ref2[0],
          currentMinSize = _ref2[1];
        // FIXME: move actual check to the visitor
        var matchesInterval = function matchesInterval() {
          var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$maxSize = _ref3.maxSize,
            maxSize = _ref3$maxSize === void 0 ? PARAM_EMPTY_VALUE : _ref3$maxSize,
            _ref3$minSize = _ref3.minSize,
            minSize = _ref3$minSize === void 0 ? null : _ref3$minSize;
          return createInterval(maxSize, minSize).overlapsWith(currentMaxSize, currentMinSize);
        };
        visitor.visit(_this3.value[currentMaxSize], {
          maxSize: currentMaxSize,
          minSize: currentMinSize,
          matchesInterval: matchesInterval
        });
      });
    }
  }]);
  return AdaptiveDecorator;
}(AdaptiveProjection);